<template>
  <NxInput
    :name="'data-' + variable"
    type="date"
    :label="'Data ' + variable + ':'"
    :max="maxToday ? getCurrentDate() : false"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxInputDate',
  mixins: [useReactiveModelMixin('value')],
  props: {
    variable: {
      type: String,
      required: true,
      default: null
    },
    maxToday: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    },
    getCurrentDate () {
      let date = new Date()
      let day = String(date.getDate()).padStart(2, '0')
      let month = String(date.getMonth() + 1).padStart(2, '0') // January is 0!
      let year = date.getFullYear()

      let currentDate = year + '-' + month + '-' + day

      return currentDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDate.vue